import { useState, useEffect, useCallback } from 'react'
import { useVestigioService } from 'hooks/useVestigioService'

export const useAnaliseConstatacao = (idExameSolicitado) => {
  const vestigioService = useVestigioService()
  const [vestigios, setVestigios] = useState([])
  const [processandoVestigios, setProcessandoVestigios] = useState(false)

  const fetchVestigiosDeExameSolicitado = useCallback(async () => {
    if (idExameSolicitado) {
      setProcessandoVestigios(true)
      try {
        const response = await vestigioService.listarVestigiosDeExameSolicitadoAsync(
          idExameSolicitado,
          setProcessandoVestigios
        )
        setVestigios(response)
      } catch (error) {
        console.error('Error fetching vestigios of exame solicitado:', error)
      } finally {
        setProcessandoVestigios(false)
      }
    }
  }, [idExameSolicitado]) // Excluded vestigioService to prevent infinite loop

  useEffect(() => {
    fetchVestigiosDeExameSolicitado()
  }, [fetchVestigiosDeExameSolicitado])

  return {
    vestigios,
    processandoVestigios,
  }
}
